/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseProductDetailFragment, ProductDetailFragment, FullProductDetailFragment} from '@amblique/contentful/app/contentful/fragments/product-detail';

/**
 * Get a single ProductDetail by ID (base - scalars only)
 */
export const getBaseProductDetailById = gql`
  ${BaseProductDetailFragment}

  query GetBaseProductDetailById($id: String!, $locale: String!, $preview: Boolean) {
    productDetail(id: $id, locale: $locale, preview: $preview) {
      ...BaseProductDetailFragment
    }
  }
`;

/**
 * Get a single ProductDetail by ID (standard - 1 level deep)
 */
export const getProductDetailById = gql`
  ${ProductDetailFragment}

  query GetProductDetailById($id: String!, $locale: String!, $preview: Boolean) {
    productDetail(id: $id, locale: $locale, preview: $preview) {
      ...ProductDetailFragment
    }
  }
`;

/**
 * Get a single ProductDetail by ID (full - 2 levels deep)
 */
export const getFullProductDetailById = gql`
  ${FullProductDetailFragment}

  query GetFullProductDetailById($id: String!, $locale: String!, $preview: Boolean) {
    productDetail(id: $id, locale: $locale, preview: $preview) {
      ...FullProductDetailFragment
    }
  }
`;

/**
 * Get all ProductDetail entries with pagination (base - scalars only)
 */
export const getBaseProductDetails = gql`
  ${BaseProductDetailFragment}

  query GetBaseProductDetails(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ProductDetailOrder]
    $where: ProductDetailFilter
    $preview: Boolean
  ) {
    productDetailCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseProductDetailFragment
      }
    }
  }
`;

/**
 * Get all ProductDetail entries with pagination (standard - 1 level deep)
 */
export const getProductDetails = gql`
  ${ProductDetailFragment}

  query GetProductDetails(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ProductDetailOrder]
    $where: ProductDetailFilter
    $preview: Boolean
  ) {
    productDetailCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...ProductDetailFragment
      }
    }
  }
`;

/**
 * Get all ProductDetail entries with pagination (full - 2 levels deep)
 */
export const getFullProductDetails = gql`
  ${FullProductDetailFragment}

  query GetFullProductDetails(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ProductDetailOrder]
    $where: ProductDetailFilter
    $preview: Boolean
  ) {
    productDetailCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullProductDetailFragment
      }
    }
  }
`;
